import { render, staticRenderFns } from "./NoLibraryBagicTable.vue?vue&type=template&id=27acbe78&scoped=true"
import script from "./NoLibraryBagicTable.vue?vue&type=script&lang=js"
export * from "./NoLibraryBagicTable.vue?vue&type=script&lang=js"
import style0 from "./NoLibraryBagicTable.vue?vue&type=style&index=0&id=27acbe78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27acbe78",
  null
  
)

export default component.exports